/*
 * course-image-guard — casual-copy deterrent for the generated course art.
 *
 * NOT protection, and nothing here pretends to be. The preview is a public PNG
 * on the asset CDN; its URL is in the DOM, in the network tab and in the cart's
 * line-item properties, so anyone willing to open devtools already has it. What
 * this removes is the *accidental* path: the customer who right-clicks "Save
 * image as…", opens the art in a new tab, or drags it onto the desktop, and
 * walks the result to another embroiderer. The defence that actually matters is
 * resolution — see WEB_PREVIEW_WIDTH in the generation API.
 *
 * Pairs with the pointer-events rules in component-course-designer.css. Those do
 * most of the job (the browser hit-tests past the <img>, so the native image
 * menu never opens); this catches what CSS can't — dragstart, and any context
 * menu that still lands inside a design frame.
 *
 * Delegated from the document, so it keeps working after a colour swap replaces
 * the gallery DOM, and scoped to the design frames only: the rest of the page
 * keeps its normal right-click.
 */
(function () {
  'use strict';

  // The frames that wrap generated course art. `.course-overlay` and the cart /
  // upsell overlays are already pointer-events: none, so events rarely land in
  // them — they are listed so the guard still holds if that ever changes.
  var FRAMES =
    '.course-overview, .course-overlay, .course-upsell__overlay, .cart-item__map-overlay';

  function inDesignFrame(node) {
    return !!(node && node.closest && node.closest(FRAMES));
  }

  document.addEventListener('contextmenu', function (e) {
    if (inDesignFrame(e.target)) e.preventDefault();
  });

  // Covers the drag-to-desktop / drag-into-another-tab route, including the
  // browsers that ignore -webkit-user-drag.
  document.addEventListener('dragstart', function (e) {
    if (inDesignFrame(e.target)) e.preventDefault();
  });
})();
